<template>
  <div class="card shadow p-2 position-relative">
    <div
      class="position-absolute d-lg-none"
      style="max-width:100px; width: 100px; top: -10px"
    >
      <div
        class="badge badge-pill rounded-pill px-2"
        :class="`bg-${formattedStatus.color} text-${formattedStatus.textColor || 'blue-700'}`"
      >
        {{ formattedStatus.text }}
      </div>
    </div>
    <div class="card-body">
      <div
        class="d-flex flex-md-row flex-column
        justify-content-between w-100"
      >
        <div class="d-flex flex-column my-auto max-width-product-name">
          <div class="d-flex mb-2">
            <v-highlight
              :product-id="contract.productId || 0"
              :product-name="productName"
            />
          </div>
          <div class="d-flex lead">
            N° {{ contract.reference }}
          </div>
          <div
            v-if="contract.productId === 16"
            class="d-flex mt-2"
          >
            {{ formattedAddress }}
          </div>
          <div
            v-else-if="mainActivity"
            class="d-flex mt-2 text-truncate small"
          >
            <span class="text-truncate">
              {{ mainActivity }}
            </span>
          </div>
        </div>
        <div
          class="d-flex flex-column my-lg-auto my-2"
          style="max-width:120px; width: 120px"
        >
          <div class="d-flex">
            {{ formattedEffectiveDate }}
          </div>
        </div>
        <div
          class="my-auto text-center d-none d-lg-flex"
          style="max-width:100px; width: 100px"
        >
          <div
            class="badge badge-pill rounded-pill px-2"
            :class="`bg-${formattedStatus.color} text-${formattedStatus.textColor || 'blue-700'}`"
          >
            {{ formattedStatus.text }}
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row my-auto">
          <div :class="haveContractDocument ? 'd-md-flex my-auto' : 'invisible'">
            <v-download :action="downloadDocument" />
          </div>
          <router-link
            v-if="contract.delegation || !contract.visible"
            v-slot="{ navigate }"
            :to="`/client/documents/${contract.productId}/${contract.id}`"
            custom
          >
            <button
              type="button"
              class="btn btn-primary my-auto text-nowrap"
              @click="navigate"
              @keypress.enter="navigate"
            >
              <div class="d-flex flex-row">
                <div class="ms-auto me-1">
                  Voir le détail
                </div>
                <v-icon
                  icon="arrow-white-right"
                  class="me-auto"
                />
              </div>
            </button>
          </router-link>
          <v-loader
            :next="downloadDocument"
            color="blue-600"
            title="Télécharger"
            icon="download-white"
            class="d-md-none mt-2 w-100"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { has, get } from 'lodash-es';
import { mapGetters } from 'vuex';

import { formatDate } from '@/utils/_Date';

import ProductHighlight from '@/components/common/helpers/ProductHighlight.vue';
import DownloadButton from '@/components/common/helpers/DownloadButton.vue';

export default {
  name: 'ContractDisplay',
  components: {
    'v-highlight': ProductHighlight,
    'v-download': DownloadButton,
  },
  props: {
    contract: {
      type: Object,
      required: true,
      default: () => ({
        grid: { product: { name: null } },
      }),
    },
  },
  computed: {
    ...mapGetters({
      products: 'rater/products',
    }),
    productName() {
      return (this.products
        .find(({ id }) => id === this.contract.productId)
        || {})
        .name;
    },
    mainActivity() {
      return get(this.contract, 'risk.mainActivity.name', null);
    },
    formattedAddress() {
      if (!has(this.contract, 'risk.local.address')) {
        return '';
      }
      const { address } = this.contract.risk.local;
      return `${address.street}, ${address.city}`;
    },
    formattedStatus() {
      const status = [
        { id: 'ACTIVE', text: 'Actif', color: 'green-300' },
        {
          id: 'EXPIRED', text: 'Résilié', color: 'pink-700', textColor: 'white',
        },
        { id: 'SUSPENDED', text: 'Suspendu', color: 'gray-300' },
        {
          id: 'CANCELLED', text: 'Résilié', color: 'pink-700', textColor: 'white',
        },
      ];
      return status
        .find(({ id }) => id === this.contract.status)
        || {};
    },
    formattedEffectiveDate() {
      return formatDate(this.contract.effectiveDate);
    },
    haveContractDocument() {
      return this.contract.documents
        .some(({ type }) => type === 'POLICY');
    },
  },
  methods: {
    downloadDocument() {
      if (this.haveContractDocument) {
        return this.$store.dispatch('download/downloadPolicy', this.contract);
      }
      return Promise.resolve();
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 576px) {
  .max-width-product-name {
    width: 400px;
    max-width: 400px;
  }
}
</style>
